// src/hooks/useActivityQueue.ts
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Roles } from '../constants/Roles';
import { ACTIVITY_ENABLED, sendActivityAfterLogin } from '../services/activity';
import { getUserData } from '../views/auth/slice/selectors';

// Monitoring aktywności: niewysłane próby ucznia idą zaraz po jego zalogowaniu i przy otwarciu aplikacji na jego
// koncie, bez czekania na grę. Na koncie nauczyciela nic nie robi
const useActivityQueue = (): void => {
  const user = useSelector(getUserData);
  const studentId = ACTIVITY_ENABLED && user?.role === Roles.STUDENT ? user.id : undefined;

  useEffect(() => {
    if (studentId) sendActivityAfterLogin(studentId);
  }, [studentId]);
};

export default useActivityQueue;
